import * as layerSupport from "./layerSupport";
import * as paymentResolvers from "./paymentResolvers";
import * as dates from "common/dates";
import * as numbers from "common/numbers";

// A program status reason explains the status it was recorded against
// (statusReasonStatus). The program status can move on without anyone
// touching the reason, for example when a layer status changes, so the
// reason only stands while the program is still in that status.
export const resolveStatusReason = (program, status) =>
  program?.statusReasonStatus == null || program.statusReasonStatus === status
    ? program?.statusReason ?? null
    : null;

export const resolveProgram = (program, { layerInputs } = {}) => {
  let inception = program.inception;
  if (isNaN(new Date(program.inception).getTime())) {
    inception = dates.getFirstOfNextMonthStrNoTimeZone();
  }
  const expiration =
    program.expiration || dates.getMoveForwardOneYear(inception);
  const proRataAdjustment =
    program.proRataAdjustment != null && program.proRataAdjustment !== ""
      ? numbers.parseFloatOrNull(program.proRataAdjustment)
      : program.cancelAtFirstAnniversary
      ? 100
      : dates.yearsBetween(expiration, inception) * 100;

  const effectiveDate = program.effectiveDate ?? inception;

  const paymentTerms = paymentResolvers.resolvePaymentTerms(
    program.paymentTerms,
    { fromDateString: effectiveDate }
  );

  // A cancel-and-rewrite deal's cover is expected to end at the first
  // anniversary, so that is its effective end unless a date is recorded
  // explicitly.
  const effectiveExpiration =
    program.effectiveExpiration ||
    (program.cancelAtFirstAnniversary
      ? dates.getMoveForwardOneYear(inception)
      : expiration);

  const status =
    program.status ?? layerSupport.extractProgramStatus(layerInputs);

  const out = {
    ...program,
    inception,
    expiration,
    effectiveExpiration,
    proRataAdjustment,
    paymentTerms,
    status,
    transaction:
      program.transaction ?? (program.priorSubmission ? "RENEWAL" : "NEW"),
    // a cancel-and-rewrite deal is by definition multi-year
    ...(program.cancelAtFirstAnniversary ? { isMultiYear: true } : {}),
    ...(program.statusReason != null
      ? { statusReason: resolveStatusReason(program, status) }
      : {}),
  };

  if (program.targetTotalExpenses != null && program.expenses == null) {
    const otherExpenses = program.brokerage ?? 0.0;
    out.expenses = program.targetTotalExpenses - otherExpenses;
  }

  return out;
};
